'use strict';
module.exports = require('./Card.vue');